import type { ISpread } from "../../spreadsSlice";

export const treeOfLifeSpread: ISpread = {
  id: "spread_tree_of_life",
  name: "Древо Жизни",
  altNames: ["Tree of Life Spread"],
  purpose:
    "Глубокое исследование структуры личности, связей между разными уровнями опыта, духовного пути и жизненных задач.",
  cardsCount: 10,
  layout: `[1]  [2]
[3]  [4]
[5]  [6]
[7]  [8]
[9] [10]`,
  positions: [
    {
      id: "kether",
      title: "Кетер — Корона",
      meaning: "Высшее «Я» и духовный потенциал.",
    },
    {
      id: "chokmah",
      title: "Хокма — Мудрость",
      meaning: "Вдохновение и творческий импульс.",
    },
    {
      id: "binah",
      title: "Бина — Понимание",
      meaning: "Осознание формы и структуры.",
    },
    {
      id: "chesed",
      title: "Хесед — Милосердие",
      meaning: "Ресурсы и дарования.",
    },
    {
      id: "gevurah",
      title: "Гвура — Сила",
      meaning: "Испытания и ограничения.",
    },
    {
      id: "tiphareth",
      title: "Тиферет — Красота",
      meaning: "Сердцевина и гармония.",
    },
    {
      id: "netzach",
      title: "Нецах — Победа",
      meaning: "Активное проявление в мире.",
    },
    {
      id: "hod",
      title: "Ход — Слава",
      meaning: "Внутренние реакции и эмоции.",
    },
    {
      id: "yesod",
      title: "Йесод — Основание",
      meaning: "Подсознательные программы.",
    },
    {
      id: "malkuth",
      title: "Малкут — Царство",
      meaning: "Проявленный результат.",
    },
  ],
  symbolism:
    "Древо Жизни рассматривается как карта души: верхние сферы связаны с духовным планом, средние — с личностью и характером, нижние — с поведением и проявлением в мире.",
  archetypes: ["Древо Жизни", "Духовный путь", "Целостная структура"],
  psychology:
    "Помогает увидеть взаимодействие духовного и материального и определить, в какой части структуры возникает напряжение или блокировка.",
  procedure: {
    preparation:
      "Сформулировать вопрос о структуре своего опыта, потенциале или духовном пути.",
    steps:
      "Перетасовать колоду; выложить десять карт по схеме Древа Жизни; читать позиции последовательно сверху вниз и затем сопоставлять связи между сферами.",
  },
  interpretations: [
    "Кетер может показывать основную духовную направленность.",
    "Тиферет отражает центральную точку гармонии личности.",
    "Малкут показывает, как вся структура проявляется в конкретном результате.",
  ],
  nuances: [
    "Не пытаться сразу свести весь расклад к одному выводу.",
    "Особенно важно рассматривать связь между Кетер и Малкут.",
    "Повторяющиеся мотивы в разных сферах могут показывать ключевые энергии расклада.",
  ],
  examples: [
    {
      cards: ["Солнце", "Маг", "Императрица", "", "", "Звезда", "", "", "", "Колесница"],
      interpretation:
        "Духовный потенциал связан с ясностью, творческим импульсом и созиданием; центральная гармония выражена через надежду, а проявленный результат — через движение вперёд.",
    },
  ],
  selfQuestions: [
    "Какая сфера требует наибольшего внимания?",
    "Где мои ресурсы, а где препятствия?",
    "Как соединить высшие устремления и повседневную жизнь?",
  ],
};

